var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'highlight' : _vm.highlight }},[_vm._t("header"),_vm._t("subheader"),_c('div',{staticClass:"sc-comparison-table-column-rows"},[_vm._t("row")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }